import { render, staticRenderFns } from "./ProductUpsellCard.vue?vue&type=template&id=33f86b72&scoped=true&lang=pug&"
import script from "./ProductUpsellCard.vue?vue&type=script&lang=js&"
export * from "./ProductUpsellCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductUpsellCard.vue?vue&type=style&index=0&id=33f86b72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f86b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f86b72')) {
      api.createRecord('33f86b72', component.options)
    } else {
      api.reload('33f86b72', component.options)
    }
    module.hot.accept("./ProductUpsellCard.vue?vue&type=template&id=33f86b72&scoped=true&lang=pug&", function () {
      api.rerender('33f86b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductUpsellCard.vue"
export default component.exports